import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor } from 'src/app/common/interceptors/api.interceptor';
import { Globals } from 'src/app/common/globals';
import { CommonService } from 'src/app/common/services/common.service';
import { AuthGuard } from 'src/app/common/guards/auth.guard';
import { SetCurrentLinkGuard } from 'src/app/common/guards/set-current-link.guard';
import { RolePermissionGuard } from 'src/app/common/guards/role-permission.guard';
import { PaymentHistoryComponent } from './app-profile/payment-history/payment-history.component';
import { FacilityPermissionGuard } from './common/guards/facility-permission.guard';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';

const Guard = [SetCurrentLinkGuard, AuthGuard, RolePermissionGuard];

const routes: Routes = [
  {
    path: 'create-account',
    loadChildren: () =>
      import('./app-create-account/app-create-account.module').then(
        (m) => m.AppCreateAccountModule
      ),
    canActivate: Guard,
  },
  {
    path: 'credential-registry',
    loadChildren: () =>
      import('./app-credential-registry/app-credential-registry.module').then(
        (m) => m.AppCredentialRegistryModule
      ),
    canActivate: Guard,
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./app-forgot-password/app-forgot-password.module').then(
        (m) => m.AppForgotPasswordModule
      ),
    canActivate: Guard,
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./app-profile/app-profile.module').then(
        (m) => m.AppProfileModule
      ),
    canActivate: Guard,
  },
  { path: 'payment-history', component: PaymentHistoryComponent, canActivate: Guard },
  {
    path: 'settings',
    loadChildren: () =>
      import('./app-profile/app-profile.module').then(
        (m) => m.AppProfileModule
      ),
    canActivate: Guard,
  },

  {
    path: 'professional',
    loadChildren: () =>
      import('./app-professional/app-professional.module').then((m) => m.AppProfessionalModule),
    canActivate: Guard,
  },

  {
    path: 'my-admin',
    loadChildren: () =>
      import('./app-admin/app-admin.module').then((m) => m.AppAdminModule),
    canActivate: Guard,
  },

  {
    path: 'manage',
    loadChildren: () =>
      import('./app-manage/app-manage.module').then((m) => m.AppManageModule),
    canActivate: Guard,
  },
  {
    path: 'my-activities',
    loadChildren: () => import('./app-ceu-management/app-ceu-management.module').then(m => m.AppCeuManagementModule),
    canActivate: Guard,
  },
  {
    path: 'facility',
    loadChildren: () => import('./app-facility/app-facility.module').then(m => m.AppFacilityModule),
    canActivate: [...Guard, FacilityPermissionGuard],
  },
  {
    path: 'facility-store',
    loadChildren: () => import('./app-store/app-store.module').then(m => m.AppStoreModule),
    canActivate: [...Guard, FacilityPermissionGuard],
  },
  {
    path: 'store',
    loadChildren: () => import('./app-store/app-store.module').then(m => m.AppStoreModule),
    canActivate: Guard,
  },
  {
    path: 'tickets',
    loadChildren: () => import('./app-ticketing-system/app-ticketing-system.module').then(m => m.AppTicketingSystemModule),
    canActivate: Guard,
  },
  { path: 'application-terms-conditions', component: TermsConditionsComponent, canActivate: Guard },
  {
    path: '',
    loadChildren: () =>
      import('./app-login/app-login.module').then((m) => m.AppLoginModule),
    canActivate: Guard,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    Globals,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    CommonService,
  ],
})
export class AppRoutingModule { }
